import { render, staticRenderFns } from "./businessInsurance.vue?vue&type=template&id=dbbea25c&"
import script from "./businessInsurance.vue?vue&type=script&lang=js&"
export * from "./businessInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports